<script context="module">
    export const underPaidHealthFundDetails = (encounter) => {
        let details = "";

        if (encounter.underPaidHealthFund > 0) {
            details += `Health fund underpaid $${encounter.underPaidHealthFund.toFixed(2)}. `;
        }

        if (encounter.underPaidApprovedByName) {
            details += `Approved by ${encounter.underPaidApprovedByName}. `;
        }

        return details;
    };

    export const overPaidHealthFundDetails = (encounter) => {
        let details = "";

        if (encounter.overPaidHealthFund > 0) {
            details += `Health fund overpaid $${encounter.overPaidHealthFund.toFixed(2)}. `;
        }

        if (encounter.overPaidApprovedByName) {
            details += `Approved by ${encounter.overPaidApprovedByName}.`;
        }

        return details;
    };

    export const underPaidPatientDetails = (encounter) => {
        let details = "";

        if (encounter.underPaidPatient > 0) {
            details += `Patient underpaid $${encounter.underPaidPatient.toFixed(2)}. `;
        }

        if (encounter.underPaidApprovedByName) {
            details += `Approved by ${encounter.underPaidApprovedByName}. `;
        }

        return details;
        };

    export const overPaidPatientDetails = (encounter) => {
        let details = "";

        if (encounter.overPaidPatient > 0) {
            details += `Patient overpaid $${encounter.overPaidPatient.toFixed(2)}. `;
        }

        if (encounter.overPaidApprovedByName) {
            details += `Approved by ${encounter.overPaidApprovedByName}.`;
        }

        return details;
        };

    export const underPaidDetails = (encounter) => {
        let details = "";

        if (encounter.underPaidHealthFund > 0) {
            details += `Health fund underpaid $${encounter.underPaidHealthFund.toFixed(2)}. `;
        }

        if (encounter.underPaidPatient > 0) {
            details += `Patient underpaid $${encounter.underPaidPatient.toFixed(2)}. `;
        }

        if (encounter.underPaidApprovedByName) {
            details += `Approved by ${encounter.underPaidApprovedByName}. `;
        }

        return details;
    };

    export const overPaidDetails = (encounter) => {
        let details = "";

        if (encounter.overPaidHealthFund > 0) {
            details += `Health fund overpaid $${encounter.overPaidHealthFund.toFixed(2)}. `;
        }

        if (encounter.overPaidPatient > 0) {
            details += `Patient overpaid $${encounter.overPaidPatient.toFixed(2)}. `;
        }

        if (encounter.overPaidApprovedByName) {
            details += `Approved by ${encounter.overPaidApprovedByName}.`;
        }

        return details;
    };

    export const isOverPaid = (encounter) => {
        return encounter.overPaidHealthFund > 0 || encounter.overPaidPatient > 0;
    };

    export const isOverPaidPatient = (encounter) => {
        return encounter.overPaidPatient > 0;
    };

    export const isOverPaidHealthFund = (encounter) => {
        return encounter.overPaidHealthFund > 0;
    };

    export const getPaymentStatusLabel = (id) => {
        switch (id) {
            case 0:
                return "Pending";
            case 1:
                return "Received";
            case 2:
                return "Received Externally";
            case 4:
                return "Pending refund";
            case 5:
                return "Refunded";
            case 7:
                return "Write Off";
            case 9:
                return "Cancelled";
            default:
                return "Unknown";
        }
    };
</script>
